import { render } from "./events.vue?vue&type=template&id=0b6baece&scoped=true"
import script from "./events.vue?vue&type=script&lang=ts"
export * from "./events.vue?vue&type=script&lang=ts"

import "./events.vue?vue&type=style&index=0&id=0b6baece&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b6baece"

export default script